var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c("div", { staticClass: "select-user-overlay" }, [
        _c("div", { staticClass: "container-select-user" }, [
          _c("h4", [_vm._v(_vm._s(_vm.$t("dash.select-users.title")))]),
          _c("p", [_vm._v(_vm._s(_vm.params.subTitle || "Undefined"))]),
          _c("div", { staticClass: "container-search-bar" }, [
            _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.params.valueSearch,
                  expression: "params.valueSearch",
                },
              ],
              domProps: { value: _vm.params.valueSearch },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.params, "valueSearch", $event.target.value)
                },
              },
            }),
          ]),
          _c(
            "div",
            { staticClass: "list-user" },
            _vm._l(_vm.getUserIdMatchingFilter, function (user, index) {
              return _c(
                "label",
                { staticClass: "user", on: { click: function ($event) {} } },
                [
                  _c("Checkbox", {
                    attrs: {
                      id: "selectUser" + user.id,
                      prefixId: user.id,
                      isChecked: _vm.selection.includes(user.id),
                      isDisable: false,
                      add: _vm.addUser,
                      remove: _vm.removeUser,
                    },
                  }),
                  _c("div", { staticClass: "picture" }, [
                    _c("img", {
                      attrs: {
                        src: user.avatar ? user.avatar : "img/avatar.jpg",
                      },
                      on: { error: () => _vm.imageUserOnError(user.id) },
                    }),
                  ]),
                  _c("div", { staticClass: "info no-select" }, [
                    _c("div", { staticClass: "name no-select" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            user.firstname || user.lastname
                              ? `${user.firstname} ${user.lastname}`.trim()
                              : user.email.split("@")[0]
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "badge no-select" }, [
                        _vm._v(
                          _vm._s(
                            user.admin == true
                              ? _vm.$t("dash.select-users.admin")
                              : user.role && user.role.length > 0
                              ? _vm.$t(`dash.settings.user.${user.role[0]}`)
                              : _vm.$t("dash.settings.user.Editor")
                          )
                        ),
                      ]),
                    ]),
                    _c("p", { staticClass: "email no-select" }, [
                      _vm._v(_vm._s(user.email)),
                    ]),
                  ]),
                ],
                1
              )
            }),
            0
          ),
          _vm.formCustom
            ? _c(
                "div",
                { staticClass: "form-custom" },
                _vm._l(_vm.formCustom, function (item) {
                  return (
                    typeof item.show == "function"
                      ? item.show(_vm.selection)
                      : !!item.show
                  )
                    ? _c(
                        "div",
                        { staticClass: "item" },
                        [
                          item.type == "checkbox"
                            ? _c("Checkbox", {
                                attrs: {
                                  id: item.name,
                                  prefixId: "",
                                  isChecked: item.value,
                                  isDisable: false,
                                  add: (name) => {
                                    _vm.changeValueForm(name, true)
                                  },
                                  remove: (name) => {
                                    _vm.changeValueForm(name, false)
                                  },
                                },
                              })
                            : _vm._e(),
                          _c(
                            "label",
                            {
                              staticClass: "title no-select",
                              attrs: { for: item.name },
                            },
                            [_vm._v(_vm._s(item.label))]
                          ),
                        ],
                        1
                      )
                    : _vm._e()
                }),
                0
              )
            : _vm._e(),
          _c("div", { staticClass: "btns" }, [
            _c(
              "div",
              { staticClass: "btn-primary", on: { click: _vm.validSelection } },
              [_vm._v(_vm._s(_vm.textButtonValid))]
            ),
            _c(
              "div",
              { staticClass: "btn-secondary", on: { click: _vm.cancel } },
              [_vm._v(_vm._s(_vm.$t("dash.button.cancel")))]
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }